var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createElement as _createElement } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { cloneElement, isValidElement } from "react";
import { MenuItem } from "./MenuItem";
import { MenuItemLink } from "./MenuItemLink";
import { MenuItemSeparator } from "./MenuItemSeparator";
export function defaultMenuItemRenderer(item, key) {
    if (item !== 0 && !item) {
        return null;
    }
    if (item === "separator") {
        return _jsx(MenuItemSeparator, {}, key);
    }
    var type = typeof item;
    if (type === "number" || type === "string" || type === "boolean") {
        return _jsx(MenuItem, { children: item }, key);
    }
    if (isValidElement(item)) {
        return cloneElement(item, { key: key });
    }
    var separatorProps = item;
    if (separatorProps.role === "separator") {
        return _createElement(MenuItemSeparator, __assign({}, separatorProps, { key: key }));
    }
    var linkProps = item;
    if (linkProps.to || linkProps.href || linkProps.component) {
        return _jsx(MenuItemLink, __assign({}, linkProps), key);
    }
    var itemProps = item;
    return _jsx(MenuItem, __assign({}, itemProps), key);
}
//# sourceMappingURL=defaultMenuItemRenderer.js.map